<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-angel"></i> Usuários Anjo <small>Formulário de Cadastro</small></h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-angel"></i> Usuários Anjo</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div class="card card-primary card-outline">
                            <div class="card-body box-profile">
                                <div class="text-center">
                                    <img class="profile-user-img img-fluid img-circle" :src="entity.foto" alt="">
                                </div>
                                <h3 class="profile-username text-center">
                                    <a href="javascript:;" v-if="entity.identity_check" @click="openSecretMedia()" class="btn btn-default btn-sm">
                                        <i class="fas fa-play"></i>
                                    </a>
                                    {{ entity.name }}
                                </h3>

                                <p class="text-muted text-center">{{ entity.email }}</p>

                                <ul class="list-group list-group-unbordered mb-3">
                                    <li class="list-group-item">
                                        <b>Telefone: </b> {{ entity.telefone }}
                                    </li>
                                    <li class="list-group-item">
                                        <b>Status: </b>
                                        <badge
                                            :value="entity.is_user_active"
                                            :options="[
                                                { value: true, label: 'Ativo', class: 'badge-success' },
                                                { value: false, label: 'Inativo', class: 'badge-danger' }
                                            ]"
                                        />
                                    </li>
                                    <li class="list-group-item">
                                        <b>Status de Emergência: </b>
                                        <badge
                                            :value="entity.emergencyStatus"
                                            :options="[
                                                { value: 0, label: 'Desativado', class: 'badge-secondary' },
                                                { value: 1, label: 'Alerta', class: 'badge-warning' },
                                                { value: 2, label: 'Pânico', class: 'badge-danger' },
                                                { value: 3, label: 'Emergência médica', class: 'badge-danger' }
                                            ]"
                                        />
                                    </li>
                                    <li class="list-group-item">
                                        <b>E-mail Validado: </b>
                                        <badge
                                            :value="entity.is_valid_email"
                                            :options="[
                                                { value: true, label: 'Sim', class: 'badge-success' },
                                                { value: false, label: 'Não', class: 'badge-danger' }
                                            ]"
                                        />
                                    </li>
                                    <li class="list-group-item">
                                        <b>Data de Cadastro:</b> <i class="fas fa-calendar-alt"></i> {{ entity.data_cadastro | formatDateTime }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="card card-primary">
                            <div class="card-header">
                                <h3 class="card-title"><i class="fas fa-mobile-alt"></i> Aparelho Celular</h3>
                            </div>
                            <div class="card-body">
                                <p v-if="entity.telefone">
                                    <b>Número:</b> {{ entity.telefone }}
                                </p>
                                <p v-if="entity.device_imei1">
                                    <b>IMEI 1:</b> {{ entity.device_imei1 }}
                                </p>
                                <p v-if="entity.device_imei2">
                                    <b>IMEI 2:</b> {{ entity.device_imei2 }}
                                </p>
                                <p v-if="entity.device_brand">
                                    <b>Marca:</b> {{ entity.device_brand }}
                                </p>
                                <p v-if="entity.device_model">
                                    <b>Modelo:</b> {{ entity.device_model }}
                                </p>
                                <p v-if="entity.device_system_name">
                                    <b>Sistema Operacional:</b> {{ entity.device_system_name }}
                                </p>
                                <p v-if="entity.device_system_version">
                                    <b>Versão:</b> {{ entity.device_system_version }}
                                </p>
                                <p v-if="entity.device_locale">
                                    <b>Idioma:</b> {{ entity.device_locale }}
                                </p>
                                <p v-if="entity.device_country">
                                    <b>País:</b> {{ entity.device_country }}
                                </p>
                                <p v-if="entity.device_name">
                                    <b>Nome do Celular:</b> {{ entity.device_name }}
                                </p>
                                <p v-if="entity.device_ip">
                                    <b>IP:</b> {{ entity.device_ip }}
                                </p>
                                <p v-if="entity.device_mac_adress">
                                    <b>MAC Adress:</b> {{ entity.device_mac_adress }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-9">
                        <div class="card">
                            <div class="card-header p-2">
                                <ul class="nav nav-pills">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="custom-tabs-one-location-tab" data-toggle="tab" href="#custom-tabs-one-location" role="tab" aria-controls="custom-tabs-one-location" aria-selected="false"><i class="fas fa-map"></i> Localização</a>
                                    </li>
                                    <li class="nav-item" v-if="entity.tb_emergency_media && entity.tb_emergency_media.length > 0">
                                        <a class="nav-link" id="custom-tabs-one-messages-tab" data-toggle="tab" href="#custom-tabs-one-messages" role="tab" aria-controls="custom-tabs-one-messages" aria-selected="false"><i class="fas fa-video"></i> Vídeos</a>
                                    </li>
                                    <li class="nav-item" v-if="entity.tb_emergency_contact && entity.tb_emergency_contact.length > 0">
                                        <a class="nav-link" id="custom-tabs-one-profile-tab" data-toggle="tab" href="#custom-tabs-one-profile" role="tab" aria-controls="custom-tabs-one-profile" aria-selected="false"><i class="fas fa-users"></i> Contatos de Emergência</a>
                                    </li>
                                    <li class="nav-item" v-if="entity.tb_user_bank_info && entity.tb_user_bank_info.length > 0">
                                        <a class="nav-link" id="custom-tabs-one-settings-tab" data-toggle="tab" href="#custom-tabs-one-settings" role="tab" aria-controls="custom-tabs-one-settings" aria-selected="false"><i class="fas fa-university"></i> Dados Bancários</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="card-body">
                                <div class="tab-content">
                                    <div class="tab-pane fade show active" id="custom-tabs-one-location" role="tabpanel" aria-labelledby="custom-tabs-one-location-tab">
                                        <div class="col-md-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h3 class="card-title">
                                                        <i class="fas fa-map"></i>
                                                        Localização - {{ localizacao.date | formatDateTime }}
                                                    </h3>
                                                </div>

                                                <div class="card-body">
                                                    <div class="callout callout-success">
                                                        <p>
                                                            <i class="far fa-map-marker-plus"></i> Latitude: <b>{{ localizacao.latitude }}</b> -
                                                            <i class="far fa-map-marker-minus"></i> Longitude: <b>{{ localizacao.longitude }}</b> -
                                                            <i class="fal fa-map-marker-exclamation"></i> Altitude: <b>{{ localizacao.altitude }}</b> -
                                                            <i class="far fa-tachometer-alt-slow"></i> Velocidade: <b>{{ localizacao.speed }}</b>
                                                        </p>
                                                    </div>

                                                    <iframe
                                                        width="100%"
                                                        height="600"
                                                        style="border:0"
                                                        loading="lazy"
                                                        allowfullscreen
                                                        :src="`https://www.google.com/maps?q=${localizacao.latitude},${localizacao.longitude}&layer=s&hl=pt;&output=svembed`"
                                                    ></iframe>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <div class="card-header">
                                                    <h3 class="card-title">
                                                        <i class="fas fa-route"></i>
                                                        Percurso em Pânico
                                                        <span v-if="percursoPontos.length > 0">nos últimos {{ percursoPontos.length }} pontos de atualização</span>
                                                    </h3>
                                                </div>
                                                <div class="card-body">
                                                    <div v-if="percursoPontos.length > 0" id="delivery-route-map" class="delivery-route-map"></div>

                                                    <div v-if="percursoPontos.length === 0" class="alert alert-info mt-3">
                                                        <i class="fas fa-info-circle"></i> Nenhum percurso encontrado.
                                                    </div>                                                    
                                                </div>
                                            </div>
                                            <div class="card">
                                                <div class="card-header">
                                                    <h3 class="card-title">
                                                        <i class="fas fa-users"></i> Anjos Próximos
                                                        <span v-if="nearUsers && nearUsers.length > 0">({{ nearUsers.length }})</span>
                                                    </h3>
                                                </div>
                                                <div class="card-body">
                                                    <div id="near-users-map" class="delivery-route-map"></div>

                                                    <div v-if="!nearUsers || nearUsers.length === 0" class="alert alert-info mt-3">
                                                        <i class="fas fa-info-circle"></i> Nenhum Anjo próximo encontrado.
                                                    </div>

                                                     <table class="table table-striped table-valign-middle">
                                                        <thead>
                                                        <tr>
                                                            <th>Nome</th>
                                                            <th>E-mail</th>
                                                            <th style="width: 70px;">Ver</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in nearUsers" :key="index">
                                                                <td>
                                                                    {{ item.name }}
                                                                </td>
                                                                <td>
                                                                    {{ item.email }}
                                                                </td>
                                                                <td>
                                                                    <router-link :to="{ name: 'view-user', params: { id: item.id_user } }" class="text-muted">
                                                                        <i class="fas fa-search"></i>
                                                                    </router-link>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <div class="card-header">
                                                    <h3 class="card-title">
                                                        <i class="fas fa-info-circle"></i> Outras Informações
                                                    </h3>
                                                </div>
                                                <div class="card-body">
                                                    <div id="accordion" v-if="emergencyInfo.length > 0">
                                                        <div class="card card-primary" v-for="(item, index) in emergencyInfo" :key="index">
                                                            <div class="card-header">
                                                                <h2 class="card-title w-100">
                                                                    <a class="d-block w-100" data-toggle="collapse" :href="'#collapse' + index">
                                                                        {{ item.date | formatDateTime }}
                                                                    </a>
                                                                </h2>
                                                            </div>
                                                            <div :id="'collapse' + index" class="collapse" data-parent="#accordion">
                                                                <div class="card-body">
                                                                    <pre style="display:block;background-color:#efefef;font-size:11px;color:#212529">{{ item.info }}</pre>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="!emergencyInfo || emergencyInfo.length === 0" class="alert alert-info mt-3">
                                                        <i class="fas fa-info-circle"></i> Nenhuma informação encontrada.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade" id="custom-tabs-one-messages" role="tabpanel" aria-labelledby="custom-tabs-one-messages-tab">
                                        <ul class="mailbox-attachments align-items-stretch clearfix">
                                            <li v-for="(media, index) in entity.tb_emergency_media" :key="index">
                                                <span class="mailbox-attachment-icon"><i class="far fa-video"></i></span>
                                                <div class="mailbox-attachment-info">
                                                    <a href="#" @click="openMedia(media)" class="mailbox-attachment-name"><i class="fas fa-paperclip"></i> {{ media.date | formatDateTime }}</a>
                                                    <span class="mailbox-attachment-size clearfix mt-1">
                                                        <span>1,245 KB</span>
                                                        <a href="#" @click="openMedia(media)" class="btn btn-default btn-sm float-right"><i class="fas fa-play"></i></a>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="tab-pane fade" id="custom-tabs-one-profile" role="tabpanel" aria-labelledby="custom-tabs-one-profile-tab">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>E-mail</th>
                                                    <th>Aceito?</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in entity.tb_emergency_contact" :key="index">
                                                    <td>{{ item.name }}</td>
                                                    <td>{{ item.email }}</td>
                                                    <td>
                                                        <badge
                                                            :value="item.is_accepted"
                                                            :options="[
                                                                { value: true, label: 'Sim', class: 'badge-success' },
                                                                { value: false, label: 'Não', class: 'badge-danger' }
                                                            ]"
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="tab-pane fade" id="custom-tabs-one-settings" role="tabpanel" aria-labelledby="custom-tabs-one-settings-tab">
                                        <div class="col-md-6" v-for="(banco, index) in entity.tb_user_bank_info" :key="index">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h3 class="card-title">
                                                        <i class="fas fa-university"></i>
                                                        {{ banco.bank_name }}
                                                    </h3>
                                                </div>
                                                <div class="card-body">
                                                    <p>
                                                        <b>PIX:</b> {{ banco.pix }}
                                                    </p>
                                                    <p>
                                                        <b>CPF/CNPJ:</b> {{ banco.cpf_cnpj }}
                                                    </p>
                                                    <p>
                                                        <b>Cartão de Crédito: </b>
                                                        <badge
                                                            :value="banco.credit_card"
                                                            :options="[
                                                                { value: true, label: 'Sim', class: 'badge-success' },
                                                                { value: false, label: 'Não', class: 'badge-danger' }
                                                            ]"
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- /.col -->
                </div>
            </div>
        </section>

        <div class="modal fade" id="mediaModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fas fa-video"></i> {{ media.video_data | formatDateTime }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                        <video width="640" height="360" controls v-if="media.video_url">
                            <source :src="media.video_url" type="video/mp4">
                            Seu navegador não suporta a tag de vídeo.
                        </video>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default btn-social" data-dismiss="modal"><i class="fas fa-window-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="secretMediaModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fas fa-video"></i> {{ secretMedia.video_data | formatDateTime }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                        <video width="640" height="360" controls v-if="secretMedia.video_url">
                            <source :src="secretMedia.video_url" type="video/mp4">
                            Seu navegador não suporta a tag de vídeo.
                        </video>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default btn-social" data-dismiss="modal"><i class="fas fa-window-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserController from "@/controllers/user.controller";
import EmergencyMediaController from "@/controllers/emergency_media.controller";
import UserLocationController from "@/controllers/user_location.controller";
import UserLocationHistoryController from "@/controllers/user_location_history.controller";
import EmergencyInfoController from "@/controllers/emergency_info.controller";
import format from "date-fns/format";

export default {
    data: function () {
        return {
            entity: {},
            media: {},
            secretMedia: {},
            localizacao: {},
            emergencyInfo: [],
            nearUsers: [],
            nearRadiusMeters: 400,
            localizacaoIntervalId: null,
            nearIntervalId: null,

            routeMap: null,
            routeFeatureGroup: null,

            nearUsersMap: null,
            nearUsersLayerGroup: null,
            currentUserMarker: null,
            currentUserRadiusCircle: null,
            isNearUsersMapInitialized: false,

            blueMarkerIcon: null,
            greenMarkerIcon: null,
            redMarkerIcon: null,

            percursoPontos: [],
            bootstrapTabShownHandler: null
        };
    },
    mounted() {
        const vm = this;
        const id = parseInt(this.$route.params.id, 10);

        this.$validator.validate("#form1");

        this.loadEntity(id);
        this.getLocation();
        this.getNearUsers();
        this.getEmergencyInfo();

        this.localizacaoIntervalId = setInterval(function () {
            vm.getLocation();
        }, 8000);

        this.nearIntervalId = setInterval(function () {
            vm.getNearUsers();
        }, 20000);

        this.$nextTick(async () => {
            await this.loadLeafletAssets();
            this.bindTabEvents();
            this.getLocationHistory();
            this.renderNearUsersMap();
        });

        $(":input").inputmask();
    },
    beforeDestroy() {
        this.unbindTabEvents();

        if (this.localizacaoIntervalId) {
            clearInterval(this.localizacaoIntervalId);
        }

        if (this.nearIntervalId) {
            clearInterval(this.nearIntervalId);
        }

        if (this.routeMap) {
            this.routeMap.remove();
            this.routeMap = null;
        }

        if (this.nearUsersMap) {
            this.nearUsersMap.remove();
            this.nearUsersMap = null;
        }

        this.routeFeatureGroup = null;
        this.nearUsersLayerGroup = null;
        this.currentUserMarker = null;
        this.currentUserRadiusCircle = null;
        this.isNearUsersMapInitialized = false;

        this.blueMarkerIcon = null;
        this.greenMarkerIcon = null;
        this.redMarkerIcon = null;
    },
    watch: {
        "$route.params.id": {
            handler(newId) {
                const id = parseInt(newId, 10);

                this.entity = {};
                this.localizacao = {};
                this.media = {};
                this.nearUsers = [];
                this.percursoPontos = [];
                this.emergencyInfo = [];

                if (this.routeMap) {
                    this.routeMap.remove();
                    this.routeMap = null;
                }

                if (this.nearUsersMap) {
                    this.nearUsersMap.remove();
                    this.nearUsersMap = null;
                }

                this.routeFeatureGroup = null;
                this.nearUsersLayerGroup = null;
                this.currentUserMarker = null;
                this.currentUserRadiusCircle = null;
                this.isNearUsersMapInitialized = false;

                this.loadEntity(id);
                this.getLocation();
                this.getNearUsers();
                this.getEmergencyInfo();

                this.$nextTick(async () => {
                    await this.loadLeafletAssets();
                    this.bindTabEvents();
                    this.getLocationHistory();
                    this.renderNearUsersMap();
                });
            }
        }
    },
    methods: {
        loadEntity: function (id) {
            if (id === 0)
                return;

            UserController.getById(id)
                .then(response => {
                    this.entity = response.data.result;
                });
        },

        getLocation() {
            const id = parseInt(this.$route.params.id, 10);

            if (id === 0)
                return;

            UserLocationController.getLocation(id)
                .then(response => {
                    this.localizacao = response.data;

                    this.$nextTick(() => {
                        this.renderNearUsersMap();
                    });
                });
        },

        getNearUsers() {
            const id = parseInt(this.$route.params.id, 10);

            if (id === 0)
                return;

            UserLocationController.getNearUsers(id)
                .then(response => {
                    this.nearUsers = response.data?.result || [];

                    this.$nextTick(() => {
                        this.renderNearUsersMap();
                    });
                });
        },

        getLocationHistory() {
            const id = parseInt(this.$route.params.id, 10);

            if (id === 0)
                return;

            UserLocationHistoryController.getHistory(id)
                .then(response => {
                    this.percursoPontos = response.data.result || [];

                    this.$nextTick(() => {
                        this.renderRouteMap();
                    });
                });
        },

        getEmergencyInfo() {
            const id = parseInt(this.$route.params.id, 10);

            if (id === 0)
                return;

            EmergencyInfoController.getListByUser(id)
                .then(response => {
                    this.emergencyInfo = response.data?.result || [];
                });
        },

        openMedia(emergency_media) {
            this.media = {};

            EmergencyMediaController.getMediaURL(emergency_media.id_emergency_media)
                .then(response => {
                    this.media = {
                        video_url: response.data.url,
                        video_data: emergency_media.date
                    };

                    $("#mediaModal").modal("show");
                });
        },

        openSecretMedia() {
            this.secretMedia = {};

            if (!this.entity.identity_check)
                return;

            this.secretMedia = {
                video_url: this.entity.identity_check,
                video_data: this.entity.data_cadastro
            };

            $("#secretMediaModal").modal("show");
        },

        back: function () {
            this.$router.push({ name: "list-user" });
        },

        bindTabEvents() {
            this.unbindTabEvents();

            this.bootstrapTabShownHandler = () => {
                this.$nextTick(() => {
                    if (this.routeMap) {
                        this.routeMap.invalidateSize();
                        this.renderRouteMap();
                    }

                    if (this.nearUsersMap) {
                        this.nearUsersMap.invalidateSize();
                        this.renderNearUsersMap();
                    }
                });
            };

            $('a[data-toggle="tab"]').on("shown.bs.tab", this.bootstrapTabShownHandler);
        },

        unbindTabEvents() {
            if (this.bootstrapTabShownHandler) {
                $('a[data-toggle="tab"]').off("shown.bs.tab", this.bootstrapTabShownHandler);
                this.bootstrapTabShownHandler = null;
            }
        },

        loadLeafletAssets() {
            return new Promise((resolve, reject) => {
                if (window.L) {
                    resolve();
                    return;
                }

                const cssId = "leaflet-css";
                const jsId = "leaflet-js";

                if (!document.getElementById(cssId)) {
                    const link = document.createElement("link");
                    link.id = cssId;
                    link.rel = "stylesheet";
                    link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
                    document.head.appendChild(link);
                }

                const existingScript = document.getElementById(jsId);

                if (existingScript) {
                    existingScript.addEventListener("load", resolve);
                    existingScript.addEventListener("error", reject);
                    return;
                }

                const script = document.createElement("script");
                script.id = jsId;
                script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        },

        ensureLeafletIcons() {
            if (!window.L) {
                return;
            }

            if (!this.blueMarkerIcon) {
                this.blueMarkerIcon = new window.L.Icon({
                    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
                    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });
            }

            if (!this.greenMarkerIcon) {
                this.greenMarkerIcon = new window.L.Icon({
                    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
                    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });
            }

            if (!this.redMarkerIcon) {
                this.redMarkerIcon = new window.L.Icon({
                    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
                    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });
            }
        },

        initRouteMap() {
            if (!window.L || this.routeMap) {
                return;
            }

            const mapElement = document.getElementById("delivery-route-map");

            if (!mapElement) {
                return;
            }

            this.ensureLeafletIcons();

            this.routeMap = window.L.map("delivery-route-map", {
                preferCanvas: true
            });

            window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; OpenStreetMap"
            }).addTo(this.routeMap);

            this.routeFeatureGroup = window.L.featureGroup().addTo(this.routeMap);
        },

        initNearUsersMap() {
            if (!window.L || this.nearUsersMap) {
                return;
            }

            const mapElement = document.getElementById("near-users-map");

            if (!mapElement) {
                return;
            }

            this.ensureLeafletIcons();

            this.nearUsersMap = window.L.map("near-users-map", {
                preferCanvas: true
            });

            window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; OpenStreetMap"
            }).addTo(this.nearUsersMap);

            this.nearUsersLayerGroup = window.L.layerGroup().addTo(this.nearUsersMap);

            this.currentUserMarker = window.L.marker([0, 0], {
                icon: this.blueMarkerIcon
            }).addTo(this.nearUsersMap);

            this.currentUserRadiusCircle = window.L.circle([0, 0], {
                radius: this.nearRadiusMeters || 10000,
                weight: 2,
                fillOpacity: 0.08
            }).addTo(this.nearUsersMap);

            this.isNearUsersMapInitialized = false;
        },

        renderRouteMap() {
            if (!window.L) {
                return;
            }

            const mapElement = document.getElementById("delivery-route-map");

            if (!mapElement) {
                return;
            }

            if (!this.routeMap) {
                this.initRouteMap();
            }

            if (!this.routeMap || !this.routeFeatureGroup) {
                return;
            }

            this.routeFeatureGroup.clearLayers();

            const pontosOrdenados = [...this.percursoPontos]
                .map(item => ({
                    ...item,
                    latitude: parseFloat(item.latitude),
                    longitude: parseFloat(item.longitude)
                }))
                .filter(item => !isNaN(item.latitude) && !isNaN(item.longitude))
                .sort((a, b) => new Date(a.date) - new Date(b.date));

            if (pontosOrdenados.length === 0) {
                this.$nextTick(() => {
                    if (this.routeMap) {
                        this.routeMap.invalidateSize();
                        this.routeMap.setView([0, 0], 2);
                    }
                });
                return;
            }

            const latLngs = pontosOrdenados.map(item => [item.latitude, item.longitude]);

            const polyline = window.L.polyline(latLngs, {
                color: "#007bff",
                weight: 6,
                opacity: 1
            }).addTo(this.routeFeatureGroup);

            const primeiro = pontosOrdenados[0];
            const ultimo = pontosOrdenados[pontosOrdenados.length - 1];

            window.L.marker([primeiro.latitude, primeiro.longitude], {
                icon: this.redMarkerIcon
            })
                .addTo(this.routeFeatureGroup)
                .bindPopup(`
                    <b>Início</b><br>
                    Data: ${format(new Date(primeiro.date), "dd/MM/yyyy HH:mm")}<br>
                    Latitude: ${primeiro.latitude}<br>
                    Longitude: ${primeiro.longitude}<br>
                    Altitude: ${primeiro.altitude}<br>
                    Velocidade: ${primeiro.speed}
                `);

            window.L.marker([ultimo.latitude, ultimo.longitude], {
                icon: this.greenMarkerIcon
            })
                .addTo(this.routeFeatureGroup)
                .bindPopup(`
                    <b>Fim</b><br>
                    Data: ${format(new Date(ultimo.date), "dd/MM/yyyy HH:mm")}<br>
                    Latitude: ${ultimo.latitude}<br>
                    Longitude: ${ultimo.longitude}<br>
                    Altitude: ${ultimo.altitude}<br>
                    Velocidade: ${ultimo.speed}
                `);

            pontosOrdenados.forEach((ponto, index) => {
                window.L.circleMarker([ponto.latitude, ponto.longitude], {
                    radius: 5,
                    color: "#007bff",
                    weight: 2,
                    fillColor: "#ffffff",
                    fillOpacity: 1
                })
                    .addTo(this.routeFeatureGroup)
                    .bindPopup(`
                        <b>Ponto ${index + 1}</b><br>
                        Data: ${format(new Date(ponto.date), "dd/MM/yyyy HH:mm")}<br>
                        Latitude: ${ponto.latitude}<br>
                        Longitude: ${ponto.longitude}<br>
                        Altitude: ${ponto.altitude}<br>
                        Velocidade: ${ponto.speed}
                    `);
            });

            this.$nextTick(() => {
                if (!this.routeMap || !this.routeFeatureGroup) {
                    return;
                }

                this.routeMap.invalidateSize();

                const bounds = this.routeFeatureGroup.getBounds();

                if (bounds && bounds.isValid()) {
                    this.routeMap.fitBounds(bounds, {
                        padding: [20, 20]
                    });
                } else if (polyline && polyline.getBounds().isValid()) {
                    this.routeMap.fitBounds(polyline.getBounds(), {
                        padding: [20, 20]
                    });
                }
            });
        },

        renderNearUsersMap() {
            if (!window.L) {
                return;
            }

            if (!this.localizacao || !this.localizacao.latitude || !this.localizacao.longitude) {
                return;
            }

            const mapElement = document.getElementById("near-users-map");

            if (!mapElement) {
                return;
            }

            const currentLat = parseFloat(this.localizacao.latitude);
            const currentLng = parseFloat(this.localizacao.longitude);

            if (isNaN(currentLat) || isNaN(currentLng)) {
                return;
            }

            if (!this.nearUsersMap) {
                this.initNearUsersMap();
            }

            if (!this.nearUsersMap) {
                return;
            }

            const bounds = [];

            if (!this.currentUserMarker) {
                this.currentUserMarker = window.L.marker([currentLat, currentLng], {
                    icon: this.blueMarkerIcon
                }).addTo(this.nearUsersMap);
            } else {
                this.currentUserMarker.setLatLng([currentLat, currentLng]);
            }

            this.currentUserMarker.bindPopup(`
                <b>Usuário Atual</b><br>
                Nome: ${this.entity.name || "-"}<br>
                Latitude: ${this.localizacao.latitude}<br>
                Longitude: ${this.localizacao.longitude}<br>
                Altitude: ${this.localizacao.altitude || "-"}<br>
                Velocidade: ${this.localizacao.speed || "-"}<br>
                Data: ${this.localizacao.date ? format(new Date(this.localizacao.date), "dd/MM/yyyy HH:mm") : "-"}<br>
                Raio: ${(this.nearRadiusMeters || 10000).toLocaleString("pt-BR")} m
            `);

            if (!this.currentUserRadiusCircle) {
                this.currentUserRadiusCircle = window.L.circle([currentLat, currentLng], {
                    radius: this.nearRadiusMeters || 10000,
                    weight: 2,
                    fillOpacity: 0.08
                }).addTo(this.nearUsersMap);
            } else {
                this.currentUserRadiusCircle.setLatLng([currentLat, currentLng]);
                this.currentUserRadiusCircle.setRadius(this.nearRadiusMeters || 10000);
            }

            bounds.push([currentLat, currentLng]);

            if (this.nearUsersLayerGroup) {
                this.nearUsersLayerGroup.clearLayers();
            }

            if (this.nearUsers && this.nearUsers.length > 0) {
                this.nearUsers.forEach(user => {
                    const lat = parseFloat(user.latitude);
                    const lng = parseFloat(user.longitude);

                    if (isNaN(lat) || isNaN(lng)) {
                        return;
                    }

                    bounds.push([lat, lng]);

                    window.L.marker([lat, lng], {
                        icon: this.greenMarkerIcon
                    })
                        .addTo(this.nearUsersLayerGroup)
                        .bindPopup(`
                            <b>${user.name || "Usuário"}</b><br>
                            E-mail: ${user.email || "-"}<br>
                            Distância: ${user.distance != null ? Number(user.distance).toFixed(2) + " m" : "-"}<br>
                            Latitude: ${user.latitude}<br>
                            Longitude: ${user.longitude}<br>
                            Altitude: ${user.altitude || "-"}<br>
                            Velocidade: ${user.speed || "-"}
                        `);
                });
            }

            if (!this.isNearUsersMapInitialized) {
                if (bounds.length > 1) {
                    this.nearUsersMap.fitBounds(bounds, { padding: [30, 30] });
                } else {
                    this.nearUsersMap.setView([currentLat, currentLng], 16.5);
                }

                this.isNearUsersMapInitialized = true;
            }

            this.$nextTick(() => {
                if (this.nearUsersMap) {
                    this.nearUsersMap.invalidateSize();
                }
            });
        }
    }
};
</script>

<style scoped>
.delivery-route-map {
    width: 100%;
    height: 600px;
    border: 1px solid #d2d6de;
    border-radius: 4px;
}

.current-user-marker-wrapper {
    background: transparent !important;
    border: 0 !important;
}

.current-user-marker {
    position: relative;
    width: 30px;
    height: 30px;
}
</style>